export default {"src":"/_next/static/media/facebook.e0e4be41.svg","height":35,"width":35};